import { mqLaptop, mqTabletPortrait, mqPhone } from '../../utils/mq';

document.addEventListener('alpine:init', () => {
  Alpine.data('payments101Grid', () => ({
    loadMoreWrapper: undefined,

    loadMoreButton: undefined,

    cardWrappers: undefined,

    showPerLoad: 0,

    showing: 0,

    init() {
      if (mqPhone.matches) {
        this.showPerLoad = 3;
      } else if (mqTabletPortrait.matches) {
        this.showPerLoad = 4;
      } else if (mqLaptop.matches) {
        this.showPerLoad = 6;
      } else {
        this.showPerLoad = 8;
      }

      this.showing = this.showPerLoad;

      this.$nextTick(() => {
        this.loadMoreWrapper = this.$root.querySelector('.payments-101-grid__load-more');
        this.loadMoreButton = this.loadMoreWrapper.querySelector('.button');
        this.cardWrappers = this.$root.querySelectorAll('.payments-101-grid__card-wrapper');

        this.loadMoreButton.addEventListener('click', () => {
          this.showing += this.showPerLoad;
          this.refresh();
        });

        this.refresh();
      });
    },

    refresh() {
      if (this.cardWrappers.length > this.showing) {
        this.loadMoreWrapper.classList.add('payments-101-grid__load-more--visible');
      } else {
        this.loadMoreWrapper.classList.remove('payments-101-grid__load-more--visible');
      }
    },

    card: {
      ':class'() {
        return {
          'payments-101-grid__card--hidden': +this.$el.dataset.index > this.showing,
        };
      },
    },
  }));
});